import { buildPermission } from "common/utils/auth";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";

/** read:customers:all — list and switch between any customer's data (Carbon internal). */
export const readAllCustomersStatement = buildPermission(
  PermissionAction.read,
  PermissionResource.customers,
  PermissionDomain.all
);

export const useCanSeeOtherCustomers = (): boolean =>
  useAuthorizationRequired(readAllCustomersStatement);
